import { Component, Element, h, Host, Prop, Watch } from "@stencil/core";
import { StyledComponent } from "../../../decorators/styled-component";
import {
  LINK_ICON_POSITION_LEFT,
  LINK_ICON_POSITION_RIGHT,
  LinkIconPosition
} from "../../../constants/global-constants";
// import { InitLogging } from "../../../decorators/init-logging";

@Component({
  tag: "eon-ui-linklist-item",
  styleUrl: "linklist-item.scss",
  shadow: true
})
export class LinkListItem {
  // @InitLogging() sentryTransaction;

  private linkElement: HTMLEonUiLinkElement;

  @StyledComponent() component: any;
  @Element() hostElement: HTMLEonUiLinklistItemElement;

  /**
   * Used to set icon position of the link. It can either be left or right. Default value is left.
   */
  @Prop({ reflect: true }) iconPosition: LinkIconPosition = LINK_ICON_POSITION_LEFT;

  componentWillLoad() {
    this.linkElement = this.hostElement.getElementsByTagName("EON-UI-LINK")[0] as HTMLEonUiLinkElement;
    if (this.linkElement) this.setIconPosition();
  }

  componentDidLoad() {
    this.setIconPosition();
  }

  @Watch("iconPosition")
  setIconPosition() {
    this.linkElement.iconPosition = this.iconPosition;
    this.linkElement.alignIconCenter = this.iconPosition === LINK_ICON_POSITION_RIGHT ? false : true;
  }

  render() {
    return (
      <Host>
        <slot />
      </Host>
    );
  }
}
